export default {
    url: '/notification_request',
    data: {
        title: 'Notification Request',
        priority: 890,
    },
    template: require('./view.html'),
    reloadOnSearch: false,
};
